export default "skymp5-front/0acb800c49cbe871dacdb686546aa5de.svg";